<template>
  <Dashboard
    class="page-analytics"
    v-if="item.id"
    :item="item"
    type="page"
    grid-area="leads_heading:1fr leads_heading:1fr leads_heading:1fr | status_leads:1fr status_leads:1fr status_leads:1fr | sources_leads:1fr activity_by_leads:1fr ."
  >
    <template #header>
      <HeaderComponent :title="$i18n.t('analytics')" :breadcrumb="breadcrumbs" />
    </template>
  </Dashboard>
</template>

<script>
import Dashboard from '@/components/Analytics/Dashboard'
import HeaderComponent from '@/components/Header'
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    id: String,
  },

  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  computed: {
    ...mapState('Page', ['item', 'promises']),
    breadcrumbs() {
      return [
        {
          title: (JSON.parse(sessionStorage.getItem(`page:category`)) || {}).label || this.$tc('page', 2),
          action: { name: 'pages' },
        },
        {
          title: this.item.name,
          action: { name: 'page-dashboard', params: { id: this.id } },
        },
        { title: this.$metaInfo.title },
      ].map(i => {
        if (i.action) i.action.query = this.$route.query
        return i
      })
    },
  },
  methods: {
    ...mapActions('Page', {
      fetch(dispatch) {
        return dispatch('fetch', [{ id: this.id }])
      },
    }),
  },

  metaInfo() {
    return {
      title: this.$t('analytics'),
    }
  },

  components: {
    Dashboard,
    HeaderComponent,
  },
}
</script>

<style lang="scss">
.page-analytics {
  .widget-section__border {
    display: none;
  }
}
</style>
